<ul *ngIf="paymentProviderPayMethodCollection?.length > 0; else skeletonTemplate"
    [attr.aria-label]="'Metody płatności Przelewy24'">
  <ng-container *ngIf="availablePaymentMethods.card">
    <li class="card-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentProvider]="paymentProviderIdentifier" [paymentType]="paymentMethod.CREDIT_CARD"
                            [selected]="isDefaultCardMethodSelected"
                            [paymentImgUrl]="addTimeSign(availablePaymentMethods.card.imageUrl)"
                            [paymentMethod]="availablePaymentMethods.card" [followup]="true"
                            (onPaymentProviderClick)="onSelectCreditCardMethod(availablePaymentMethods.card)">
          <ng-container *ngIf="isDefaultCardMethodSelected && showSharedCardForm">
            <ng-container [ngTemplateOutlet]="sharedCardFormTemplate"></ng-container>
          </ng-container>
        </app-payment-method>
      </div>
    </li>
  </ng-container>

  <ng-template #sharedCardFormTemplate>
    <div class="panel-body card-container d-flex flex-column gap-05 justify-content-center">
      <ng-container *ngIf="canUseSavedCardOptions && availablePaymentMethods.cardToken?.length">
        <p class="saved-cards-label f-sans" id="saved-cards-label-shared">
          {{ 'payment.provider.p24.use-saved-card' | translate }}
        </p>
        <div class="d-flex flex-wrap gap-1" role="radiogroup" aria-labelledby="saved-cards-label-shared">
          <ng-container *ngFor="let payMethod of availablePaymentMethods.cardToken; index as i">
            <ng-container [ngTemplateOutlet]="clickableCardTokenTemplate"
                          [ngTemplateOutletContext]="{ payMethod: payMethod, index: i }"></ng-container>
          </ng-container>
        </div>
      </ng-container>

      <div class="form-group card-form-group mb-0" [class.hidden]="paymentProviderStateService.selectedTokenCardMethod"
           [formGroup]="cardWithTokenizeFormGroup">
        <ng-container *ngIf="authStateService.isLogged() && canUseSavedCardOptions">
          <hr role="none" *ngIf="availablePaymentMethods.cardToken?.length" />

          <app-checkbox id="saveTokenShared" formControlName="saveToken" cssClass="ui-wrapper p24-ui-wrapper"
                        [checked]="cardWithTokenizeFormGroup.get('saveToken').value">
            <span class="agreement-text">{{ 'payment.provider.p24.remember' | translate }}</span>
          </app-checkbox>
        </ng-container>
        <div id="creditcardbox-shared" [class.ready]="creditCardFormIsLoaded"></div>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="availablePaymentMethods.blik">
    <li class="link-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentProvider]="paymentProviderIdentifier" [paymentType]="paymentMethod.BLIK"
                            [selected]="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.BLIK"
                            [paymentImgUrl]="addTimeSign(availablePaymentMethods.blik.imageUrl)"
                            [paymentMethod]="availablePaymentMethods.blik" [followup]="true"></app-payment-method>
      </div>
    </li>
  </ng-container>

  <ng-container *ngIf="availablePaymentMethods.blikT6">
    <li class="blik-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentProvider]="paymentProviderIdentifier" [paymentType]="paymentMethod.BLIK_T6"
                            [selected]="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.BLIK_T6"
                            [paymentImgUrl]="addTimeSign(availablePaymentMethods.blikT6.imageUrl)"
                            [paymentMethod]="availablePaymentMethods.blikT6" [followup]="true">
          <small label *ngIf="
              availablePaymentMethods.blikToken &&
              (!paymentProviderStateService.selectedMethod || paymentProviderStateService.selectedMethod?.type === paymentMethod.BLIK_TOKEN)
            ">{{ 'payment.provider.p24.blik-pay-direct' | translate }}
          </small>

          <div class="panel-body blik-t6-container d-flex flex-column" *ngIf="
              paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.BLIK_T6 ||
              paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.BLIK_TOKEN
            ">
            <div class="d-flex gap-1 mb-0">
              <ng-container *ngIf="canShowToggleButtonForBlik">
                <button class="btn btn-next" (click)="onToggleBlikMethod()" style="height: 50px">
                  {{
                    'payment.provider.p24.use-' + (paymentProviderStateService.selectedMethod?.type === paymentMethod.BLIK_TOKEN ? 'with' : 'without') + '-code'
                      | translate
                  }}
                </button>
              </ng-container>

              <div [formGroup]="blikFormGroup" class="form-group required mb-0"
                   [class.hidden]="paymentProviderStateService.selectedMethod?.type === paymentMethod.BLIK_TOKEN">
                <input type="text" class="form-control text-center" id="blik_t6" data-charset="_X_ X_X"
                       placeholder="___ ___" formControlName="blikCode"
                       [placeholder]="'payment.provider.p24.blik.codePlaceholder' | translate" matInput mask="000000" />
                <ng-container *ngIf="(blikFormGroup.touched && blikFormGroup.dirty) || formSubmitAttempt">
                  <span *ngIf="!blikFormGroup.get('blikCode').valid && !blikFormGroup.get('blikCode')?.errors?.minLength === true"
                        class="invalid-feedback d-inline-block">{{ 'payment.provider.p24.blik.errorMinLength' | translate }}</span>
                </ng-container>
                <input type="hidden" id="withCode" formControlName="withCode" />
              </div>
            </div>
          </div>
        </app-payment-method>
      </div>
    </li>
  </ng-container>

  <ng-container *ngIf="availablePaymentMethods.paypo">
    <li class="blik-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentProvider]="paymentProviderIdentifier" [paymentType]="paymentMethod.PAY_PO"
                            [selected]="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.PAY_PO"
                            [paymentImgUrl]="addTimeSign(availablePaymentMethods.paypo.imageUrl)"
                            [paymentMethod]="availablePaymentMethods.paypo" [followup]="true">
          <div class="panel-body paypo-container"
               *ngIf="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.PAY_PO">
            <div class="form-group mt-3" [formGroup]="paypoFormGroup">
              <div class="mb-2">
                <app-checkbox id="regulationAccept" formControlName="regulationAccept"
                              cssClass="ui-wrapper p24-ui-wrapper" ariaDescribedby="selectionRequired">
                  <ng-component *ngTemplateOutlet="regulationAcceptLabelTemplate"></ng-component>
                </app-checkbox>
              </div>

              <div formGroupName="clientAddress" class="client-address-form">
                <div
                     [class.invalid]="paypoFormGroup.get('clientAddress.address').touched && paypoFormGroup.get('clientAddress.address').invalid">
                  <label for="address">{{ 'payment.provider.p24.paypo.address' | translate }}</label>
                  <div class="w-full">
                    <input type="text" class="form-control" id="address" formControlName="address" />
                  </div>
                </div>

                <div
                     [class.invalid]="paypoFormGroup.get('clientAddress.city').touched && paypoFormGroup.get('clientAddress.city').invalid">
                  <label for="city">{{ 'payment.provider.p24.paypo.city' | translate }}</label>
                  <div class="w-full">
                    <input type="text" class="form-control" id="city" formControlName="city" />
                  </div>
                </div>

                <div
                     [class.invalid]="paypoFormGroup.get('clientAddress.zip').touched && paypoFormGroup.get('clientAddress.zip').invalid">
                  <label for="zip">{{ 'payment.provider.p24.paypo.zip' | translate }}</label>
                  <div class="w-full">
                    <input type="text" class="form-control" id="zip" formControlName="zip" mask="00-000" />
                  </div>
                </div>
              </div>

              <div *ngIf="!paypoFormGroup.valid || !paypoFormGroup.get('regulationAccept').value">
                <span
                      class="invalid-feedback d-inline-block">{{ 'payment.provider.p24.paypo.form-invalid' | translate }}</span>
              </div>
            </div>
          </div>
        </app-payment-method>
      </div>
    </li>
  </ng-container>

  <ng-container *ngIf="availablePaymentMethods.pbl?.length">
    <li class="link-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentProvider]="paymentProviderIdentifier" [paymentType]="paymentMethod.PBL"
                            [paymentImgUrl]="getDefaultPaymentImageUrl"
                            [selected]="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.PBL"
                            [followup]="true">
          <div class="panel-body pt-0"
               *ngIf="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.PBL">
            <div class="d-flex mt-3" [formGroup]="form">
              <app-checkbox id="regulationAccept" formControlName="regulationAccept"
                            cssClass="ui-wrapper p24-ui-wrapper" ariaDescribedby="selectionRequired">
                <ng-component *ngTemplateOutlet="regulationAcceptLabelTemplate"></ng-component>
              </app-checkbox>
            </div>

            <div class="pay-by-link-container mt-3">
              <lib-list [items]="availablePaymentMethods.pbl" [ariaLabel]="'payment.provider.p24.bankList' | translate"
                        [directClick]="true">
                <ng-template libListItemDef let-payMethod let-index>
                  <ng-container [ngTemplateOutlet]="clickablePblTemplate"
                                [ngTemplateOutletContext]="{ payMethod: payMethod, index: index }"></ng-container>
                </ng-template>
              </lib-list>
            </div>

            <p class="sr-only" aria-live="polite" aria-atomic="true">
              <span
                    *ngIf="paymentProviderStateService?.selectedMethod">{{ 'payment.provider.p24.selected' | translate }}
                {{ paymentProviderStateService.selectedMethod.name }}</span>
            </p>
          </div>
        </app-payment-method>
      </div>
    </li>
  </ng-container>

  <ng-container *ngIf="availablePaymentMethods.gpay">
    <li class="google-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentType]="paymentMethod.GPAY" [paymentMethod]="availablePaymentMethods.gpay"
                            [paymentProvider]="paymentProviderIdentifier"
                            [selected]="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.GPAY"
                            [paymentImgUrl]="addTimeSign(availablePaymentMethods.gpay.imageUrl)" [followup]="true">
          <div class="panel-body p-0"
               *ngIf="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.GPAY">
            <div class="gpay-container"></div>
          </div>
        </app-payment-method>
      </div>
    </li>
  </ng-container>

  <ng-container *ngIf="availablePaymentMethods.apay">
    <li class="apple-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentType]="paymentMethod.APAY" [paymentMethod]="availablePaymentMethods.apay"
                            [paymentProvider]="paymentProviderIdentifier"
                            [selected]="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.APAY"
                            [paymentImgUrl]="addTimeSign(availablePaymentMethods.apay.imageUrl)" [followup]="true">
          <div class="panel-body p-0"
               *ngIf="paymentProviderStateService.selectedPayMethodTypeCustom === paymentMethod.APAY">
            <div class="apay-container"></div>
          </div>
        </app-payment-method>
      </div>
    </li>
  </ng-container>

  <ng-container *ngIf="availablePaymentMethods.cardBnp">
    <li class="card-pay-method-container">
      <div class="pay-method-panel f-roboto">
        <app-payment-method [paymentProvider]="paymentProviderIdentifier" [paymentType]="paymentMethod.CREDIT_CARD"
                            [selected]="isBnpCardMethodSelectedForView"
                            [paymentImgUrl]="addTimeSign(availablePaymentMethods.cardBnp.imageUrl)"
                            [paymentMethod]="availablePaymentMethods.cardBnp"
                            [customLabel]="availablePaymentMethods.cardBnp.name" [followup]="true"
                            (onPaymentProviderClick)="onSelectCreditCardMethod(availablePaymentMethods.cardBnp)">
          <ng-container *ngIf="isBnpCardMethodSelectedForView && showSharedCardForm">
            <ng-container [ngTemplateOutlet]="sharedCardFormTemplate"></ng-container>
          </ng-container>
        </app-payment-method>
      </div>
    </li>
  </ng-container>
</ul>

<ng-template #clickablePblTemplate let-payMethod="payMethod">
  <button role="button" class="pay-by-link" [class.selected]="paymentProviderStateService.selectedMethod === payMethod"
          (click)="onClickPaymentMethod(payMethod)"
          [attr.aria-pressed]="paymentProviderStateService.selectedMethod === payMethod"
          [attr.aria-label]="payMethod.name">
    <ng-container *ngIf="payMethod.imageUrl">
      <img [src]="addTimeSign(payMethod.imageUrl)" aria-hidden="true" />
    </ng-container>
  </button>
</ng-template>

<ng-template #clickableCardTokenTemplate let-payMethod="payMethod">
  <button role="button" class="card"
          [class.selected]="paymentProviderStateService.selectedTokenCardMethod === payMethod"
          (click)="onClickTokenCardMethod(payMethod)"
          [attr.aria-pressed]="paymentProviderStateService.selectedTokenCardMethod === payMethod" [attr.aria-label]="
      ('payment.provider.p24.saved-card' | translate) +
      ' ' +
      (payMethod.cardBrand ? payMethod.cardBrand : '') +
      ' ' +
      (payMethod.cardMask ? payMethod.cardMask : '') +
      ' ' +
      (payMethod.cardExpirationMonth && payMethod.cardExpirationYear ? payMethod.cardExpirationMonth + '/' + payMethod.cardExpirationYear : '')
    ">
    <img [src]="payMethod.imageUrl" aria-hidden="true" />
    <p>{{ payMethod.cardBrand }}</p>
    <p>{{ payMethod.cardMask }}</p>
    <p>{{ payMethod.cardExpirationMonth }}/{{ payMethod.cardExpirationYear }}</p>
  </button>
</ng-template>

<ng-template #clickableBlikTokenTemplate let-payMethod="payMethod">
  <button class="blik" [class.selected]="paymentProviderStateService.selectedMethod === payMethod"
          (click)="onClickPaymentMethod(payMethod)">
    <p>{{ payMethod.cardBrand }}</p>
  </button>
</ng-template>

<ng-template #regulationAcceptLabelTemplate>
  <span id="rules-statement" class="agreement-text">
    {{ 'payment.provider.p24.rules-statement.beforeLink' | translate }}
    <a [href]="'payment.provider.p24.rules-statement.ruleLinkHref' | translate" target="_blank"
       rel="noopener noreferrer" (click)="$event.stopPropagation()">
      {{ 'payment.provider.p24.rules-statement.ruleLinkLabel' | translate }}
    </a>
    {{ 'payment.provider.p24.rules-statement.middleLink' | translate }}
    <a [href]="'payment.provider.p24.rules-statement.statementLinkHref' | translate" target="_blank"
       rel="noopener noreferrer" (click)="$event.stopPropagation()">
      {{ 'payment.provider.p24.rules-statement.statementLinkLabel' | translate }}
    </a>
    {{ 'payment.provider.p24.rules-statement.afterLink' | translate }}
  </span>
</ng-template>

<ng-template #skeletonTemplate>
  <ul class="skeleton-list">
    <li class="skeleton-item" *ngFor="let _ of [1, 2, 3]"></li>
  </ul>
</ng-template>

<p id="selectionRequired" class="sr-only">
  {{ 'Zaznaczenie jest wymagane' | translate }}
</p>